import { render, staticRenderFns } from "./PlanTable.vue?vue&type=template&id=22b9e195"
import script from "./PlanTable.vue?vue&type=script&lang=ts"
export * from "./PlanTable.vue?vue&type=script&lang=ts"
import style0 from "./PlanTable.vue?vue&type=style&index=0&id=22b9e195&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports